import type { SalesMetricFilter } from '@plato/app-core/gql/schema-types';
import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { SalesMetricBasis } from '@plato/app-meta/sales-metric';
import { useMemo } from 'react';

export function useDefaultMetric(): SalesMetricFilter {
    const { defaultMetric, defaultTimeframe } = useAppConfig();

    return useMemo(() => {
        return {
            basis: defaultMetric === 'Order_Sum' ? SalesMetricBasis.ORDER_SUM : SalesMetricBasis.BILLED,
            range: { preset: defaultTimeframe },
        };
    }, [defaultMetric, defaultTimeframe]);
}
